// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"59cd1006","603":"61d031c9"}[chunkId] + ".chunk.js";
};